import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CmpsCommonModule } from '../../common/common.module';
import { CmpsLazyI18nModule } from '../../i18n/i18n.module';

import { AuthComponent } from './auth.component';
import { TranslationIdMap } from './auth.i18n';
import { AuthService } from './auth.service';

@NgModule({
    declarations: [AuthComponent],
    providers: [AuthService],
    imports: [
        CmpsCommonModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CommonModule,
    ],
    exports: [AuthComponent],
})
export class CmpsTeamsCallAuthModule {}
